/** Liest den Passwort-Token aus dem URL-Fragment (`#t=<token>`, siehe auth-contract.md „Seiten-URLs“). */
export const readTokenFromHash = (hash: string): string | undefined => {
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash)
    const token = params.get("t")
    return token ? token : undefined
}

